// Clinic-local dates for C-04 and C-10 (D-21): "today" is the clinic's, not the browser's.

/** `YYYY-MM-DD` of `now` in `timeZone`. */
export function clinicToday(timeZone: string, now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now)
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? ''
  return `${get('year')}-${get('month')}-${get('day')}`
}

/** `2026-11-26` → "Thu, Nov 26, 2026" (a calendar date: no time zone shift). */
export function fmtLocalDate(date: string): string {
  const [y = 0, m = 1, d = 1] = date.split('-').map(Number)
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC',
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(Date.UTC(y, m - 1, d)))
}

/** "just now", "12 min ago", "3 hr ago", "2 days ago" (mockup `relTime`). */
export function relTime(iso: string, now: Date = new Date()): string {
  const diff = now.getTime() - new Date(iso).getTime()
  const m = Math.round(Math.abs(diff) / 60_000)
  if (m < 1) return diff < 0 ? 'in a moment' : 'just now'
  let s: string
  if (m < 60) s = `${String(m)} min`
  else if (m < 60 * 24) s = `${String(Math.round(m / 60))} hr`
  else {
    const days = Math.round(m / 1440)
    s = `${String(days)} day${days === 1 ? '' : 's'}`
  }
  return diff < 0 ? `in ${s}` : `${s} ago`
}
